import { EAdminRoles, ERouteType, RouteItem } from 'shared/types';
import React, { ComponentType, LazyExoticComponent } from 'react';

const getLazyPage = (path: string): LazyExoticComponent<ComponentType> =>
  React.lazy((): Promise<{ default: ComponentType }> => import(`pages/${path}`));

export const ROUTES: RouteItem[] = [
  {
    type: ERouteType.DEFAULT,
    path: '/d/',
    component: getLazyPage('main-page/MainPage')
  },
  {
    type: ERouteType.NOT_GUARDED,
    path: '/d/login',
    component: getLazyPage('login-page/LoginPage')
  },
  {
    type: ERouteType.DEFAULT,
    path: '/d/not-found',
    component: getLazyPage('not-found-page/NotFoundPage')
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/video-tour',
    component: getLazyPage('video-tour-page/VideoTourPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/schools',
    component: getLazyPage('schools-page/SchoolsPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/admins',
    component: getLazyPage('admins-page/AdminsPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/file-upload',
    component: getLazyPage('file-upload-page/FileUploadPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/youtube-links',
    component: getLazyPage('youtube-link-page/YoutubeLinkPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.DEFAULT,
    path: '/d/reset-password',
    component: getLazyPage('reset-password-page/ResetPasswordPage')
  },
  {
    type: ERouteType.NOT_GUARDED,
    path: '/d/forgot-password',
    component: getLazyPage('forgot-password-page/ForgotPasswordPage')
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/manage-users',
    component: getLazyPage('vr-users-page/VrUsersPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/dashboard',
    component: getLazyPage('dashboard-page/DashboardPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/sessions',
    component: getLazyPage('sessions-page/SessionsReportPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/users',
    component: getLazyPage('vr-users-page/VrUsersReportPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/le-completion-report',
    component: getLazyPage('vr-users-page/LeCompletionReportPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/le-time-stations-report',
    component: getLazyPage('vr-users-page/LeTimeStationsReportPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/student-completion-report',
    component: getLazyPage('vr-users-page/StudentCompletionReportPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/students',
    component: getLazyPage('students-admin-page/StudentsAdminPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/teacher-logins',
    component: getLazyPage('teacher-login-page/TeacherLoginPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/teacher-report',
    component: getLazyPage('teacher-report-page/TeacherReportPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/global-le-reports',
    component: getLazyPage('global-le-reports-page/GlobalLEReportsPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/watson-chat',
    component: getLazyPage('watson-chat-page/WatsonChatPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/reports/data-buddy-logs',
    component: getLazyPage('data-buddy-logs-page/DataBuddyLogsPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/help',
    component: getLazyPage('help-page/HelpPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  },
  {
    type: ERouteType.GUARDED,
    path: '/d/settings',
    component: getLazyPage('settings-page/SettingsPage'),
    allowedRoles: [EAdminRoles.SUPER_ADMIN, EAdminRoles.SCHOOL_ADMIN]
  }
];
